{
  "organization": {
    "seatOverrun": {
      "title": "Organisation gesperrt",
      "description": "Deine Organisation hat mehr Nutzer als Plätze. Ein Organisationsmanager oder Systemadministrator muss das beheben, bevor die App wieder genutzt werden kann.",
      "seatPool": "Platz-Pool",
      "resolverDescription": "Sperre oder lösche Nutzer, bis jeder Platz-Pool wieder innerhalb seines Limits liegt.",
      "stuckDescription": "Im überbelegten Platz-Pool kann von hier aus kein Platz freigegeben werden. Wende dich an den Support, damit das Platzlimit erhöht wird.",
      "overBy": "{{over}} über dem Limit",
      "loadError": "Die Platzdaten konnten nicht geladen werden."
    },
    "tabs": {
      "departments": "Abteilungen",
      "functions": "Funktionen",
      "teams": "Teams",
      "members": "Personen",
      "systems": "Systeme",
      "externalContacts": "Externe Kontakte",
      "artifacts": "Unterlagen"
    },
    "organigram": {
      "title": "Organigramm",
      "description": "Interaktives Organigramm zeigt deine Abteilungshierarchie",
      "empty": "Keine Abteilungen gefunden. Erstelle Abteilungen, um dein Organigramm aufzubauen.",
      "fitView": "An Ansicht anpassen",
      "memberCount_one": "{{count}} Person",
      "memberCount_other": "{{count}} Personen",
      "manager": "Manager",
      "notAssigned": "Nicht zugewiesen",
      "level": "Ebene"
    },
    "systems": {
      "title": "Systeme",
      "description": "Alle Systeme in deiner Organisation verwalten",
      "empty": "Keine Systeme gefunden",
      "search": "Systeme suchen...",
      "softwareSystem": "Software-System",
      "category": "Kategorie",
      "url": "Link zum System",
      "create": "System erstellen",
      "editSystem": "System bearbeiten",
      "createSystemDescription": "Füge ein neues Softwaresystem zu deiner Organisation hinzu.",
      "editSystemDescription": "Aktualisiere die Details dieses Softwaresystems",
      "namePlaceholder": "Systemnamen eingeben",
      "descriptionPlaceholder": "Systembeschreibung eingeben",
      "categoryPlaceholder": "Kategorie eingeben",
      "urlPlaceholder": "https://beispiel.de",
      "systemOwner": "Systemverantwortlicher",
      "systemOwnerPlaceholder": "Systemverantwortlichen auswählen...",
      "basicInformation": "Grundinformationen",
      "ownership": "Verantwortlichkeit",
      "systemDetails": "Systemdetails",
      "licenceSeatsLabel": "Lizenzplätze",
      "licenceSeatsPlaceholder": "z.B. 50",
      "notFound": "System nicht gefunden",
      "noDescription": "Keine Beschreibung verfügbar",
      "saveFailed": "System konnte nicht gespeichert werden",
      "logoUploadFailed": "Das System wurde gespeichert, aber das Logo konnte nicht hochgeladen werden. Du kannst das Logo später beim Bearbeiten des Systems hinzufügen.",
      "stats": {
        "totalUsers": "Benutzer gesamt",
        "totalUsersDescription": "Benutzer, die mit diesem System arbeiten",
        "totalOrgFunctions": "Funktionen gesamt",
        "totalOrgFunctionsDescription": "Funktionen, die mit diesem System arbeiten",
        "totalRoles": "Stellen gesamt",
        "totalRolesDescription": "Verschiedene Stellen der Benutzer",
        "totalProcesses": "Prozesse gesamt",
        "totalProcessesDescription": "Prozesse, die dieses System verwenden",
        "capacityBinding": "Kapazitätsbindung",
        "capacityBindingNoData": "Keine Kapazitätsdaten verfügbar",
        "perMonth": "pro Monat",
        "perYear": "pro Jahr",
        "clickToToggle": "klicken zum Wechseln",
        "costCalculation": "Kostenberechnung",
        "costPerMonth": "Kosten pro Monat",
        "costPerYear": "Kosten pro Jahr",
        "billingRateInfo": "Basierend auf einem Stundensatz von {{rate}}",
        "stepsWithData": "{{count}} von {{total}} Schritten haben Kapazitätsdaten",
        "licenceSeats": "Lizenzplätze",
        "licenceSeatsUsed": "Plätze belegt"
      },
      "capacityCell": {
        "monthSuffix": "/Mo",
        "yearSuffix": "/Jahr"
      },
      "processesImpacted": {
        "title": "Betroffene Prozesse",
        "processName": "Prozessname",
        "stepsInvolved": "Beteiligte Schritte",
        "avgRating": "Durchschn. Bewertung",
        "mediaBreaks": "Medienbrüche",
        "capacity": "Kapazität",
        "action": "Aktion",
        "viewSteps": "Schritte anzeigen",
        "noProcesses": "Noch keine Prozesse interagieren mit diesem System",
        "stepExplorer": "Schritt-Explorer"
      },
      "systemUsers": {
        "title": "Systemnutzer",
        "user": "Benutzer",
        "role": "Stelle",
        "involvedProcesses": "Beteiligte Prozesse",
        "noUsers": "Noch keine Benutzer interagieren mit diesem System",
        "searchPlaceholder": "Benutzer suchen...",
        "filterByRole": "Nach Stelle filtern",
        "allRoles": "Alle Stellen",
        "involvementType": {
          "owner": "Verantwortlich",
          "helper": "Helfer",
          "whoElseDoesThis": "Macht das auch"
        }
      },
      "topRoles": {
        "title": "Top Stellen",
        "noRoles": "Keine Stellen für dieses System gefunden",
        "allRolesTitle": "Alle Stellen"
      },
      "departments": {
        "title": "Abteilungen",
        "noDepartments": "Keine Abteilungen für dieses System gefunden",
        "membersSuffix": "Personen",
        "allDepartmentsTitle": "Alle Abteilungen"
      },
      "topOrgFunctions": {
        "title": "Top Funktionen",
        "noOrgFunctions": "Keine Funktionen für dieses System gefunden",
        "allOrgFunctionsTitle": "Alle Funktionen"
      },
      "criticalDependencies": {
        "title": "Kritische Abhängigkeitswarnung",
        "description": "Diese Prozessschritte sind von einer einzelnen Person ohne Backup abhängig. Wenn diese Person nicht verfügbar ist, kann der Schritt nicht ausgeführt werden.",
        "processStep": "Prozess / Schritt",
        "assignedTo": "Zugewiesen an",
        "role": "Stelle",
        "showAll": "Alle {{count}} anzeigen",
        "showLess": "Weniger anzeigen"
      },
      "interactions": {
        "title": "Systeminteraktionen",
        "upstream": "UPSTREAM (EINGABE)",
        "downstream": "DOWNSTREAM (AUSGABE)",
        "noUpstream": "Keine vorgelagerten Systeme",
        "noDownstream": "Keine nachgelagerten Systeme",
        "view3d": "3D",
        "viewList": "Liste",
        "viewFlow": "Flow",
        "fullscreen": "Vollbild",
        "exitFullscreen": "Vollbild beenden",
        "resetView": "Ansicht zurücksetzen",
        "pause": "Rotation pausieren",
        "play": "Rotation fortsetzen",
        "linkInteractions": "{{count}} Interaktion",
        "linkInteractions_other": "{{count}} Interaktionen"
      },
      "mediaBreakMap": {
        "title": "Medienbruch-Karte",
        "breaksBefore": "Brüche davor",
        "breaksAfter": "Brüche danach",
        "mostFrequent": "Häufigste Brüche",
        "foundInProcesses": "In {{count}} Prozessen gefunden"
      },
      "deletePhrase": "dieses System"
    },
    "departments": {
      "title": "Abteilungen",
      "description": "Übersicht aller Abteilungen in deiner Organisation",
      "empty": "Keine Abteilungen gefunden",
      "search": "Abteilungen suchen...",
      "members": "Personen",
      "noMembersFound": "Keine Personen gefunden",
      "searchMembers": "Personen suchen...",
      "teams": "Teams",
      "noTeamsFound": "Keine Teams in dieser Abteilung",
      "searchTeams": "Teams suchen...",
      "headOfDepartment": "Abteilungsleiter",
      "abbreviation": "Abkürzung",
      "create": "Abteilung erstellen",
      "editDepartment": "Abteilung bearbeiten",
      "createDepartmentDescription": "Füge eine neue Abteilung zu deiner Organisation hinzu.",
      "editDepartmentDescription": "Aktualisiere die Details dieser Abteilung",
      "namePlaceholder": "Abteilungsnamen eingeben",
      "descriptionPlaceholder": "Abteilungsbeschreibung eingeben",
      "parentDepartment": "Übergeordnete Abteilung",
      "selectParent": "Übergeordnete Abteilung auswählen",
      "manager": "Abteilungsleitung",
      "selectManager": "Abteilungsleitung auswählen",
      "relationships": "Zuordnung",
      "notFound": "Abteilung nicht gefunden",
      "detailDescription": "Abteilungsdetails anzeigen und verwalten",
      "details": "Abteilungsdetails",
      "bulkUpload": "Massenupload",
      "bulkUploadPage": {
        "title": "Abteilungen Massenupload",
        "description": "Mehrere Abteilungen mit hierarchischen Beziehungen aus Excel hochladen",
        "uploadFromExcel": "Aus Excel hochladen",
        "downloadTemplate": "Vorlage herunterladen",
        "draftDepartments": "Entwurf Abteilungen",
        "createAll": "Alle erstellen",
        "cancel": "Abbrechen",
        "fixErrorsWarning": "Bitte behebe alle Fehler vor dem Absenden",
        "successCreated": "{{count}} Abteilungen erfolgreich erstellt",
        "validationError": "Validierung fehlgeschlagen. Bitte behebe die Fehler und versuche es erneut",
        "circularDependency": "Zirkuläre Abhängigkeit in der Abteilungshierarchie erkannt",
        "parentInBatch": "Übergeordnete Abteilung wird in diesem Batch erstellt",
        "parentInDatabase": "Übergeordnete Abteilung existiert in der Datenbank",
        "parentNotFound": "Übergeordnete Abteilung nicht gefunden",
        "creationOrder": "Erstellungsreihenfolge",
        "rowNumber": "Zeile #",
        "noDrafts": "Keine Entwurf-Abteilungen. Aus Excel hochladen oder manuell hinzufügen.",
        "uploadSuccess": "{{count}} Abteilungen erfolgreich geparst",
        "uploadPartial": "{{valid}} gültige und {{invalid}} ungültige Abteilungen geparst",
        "uploadAllInvalid": "Alle {{count}} Abteilungen haben Fehler",
        "fileInvalidFormat": "Ungültiges Dateiformat. Bitte lade eine Excel-Datei hoch (.xlsx oder .xls)",
        "uploadError": "Fehler beim Hochladen der Excel-Datei",
        "addManually": "Manuell hinzufügen",
        "addManuallyDescription": "Eine einzelne Abteilung zum Batch hinzufügen",
        "editDraft": "Entwurf-Abteilung bearbeiten",
        "editDraftDescription": "Abteilungsdetails ändern",
        "confirmDeleteDraft": "Diese Abteilung aus dem Upload entfernen?",
        "parentComboPlaceholder": "Vorhandene auswählen oder Batch-Abkürzung eingeben",
        "managerEmailPlaceholder": "manager@beispiel.de",
        "validationErrors": "Validierungsfehler",
        "instruction1": "Pflichtfelder: Name und Abkürzung",
        "instruction2": "Übergeordnete Abkürzung kann auf vorhandene Abteilungen oder Abteilungen in diesem Upload verweisen",
        "instruction3": "Vermeide zirkuläre Abhängigkeiten (A → B → A)",
        "instruction4": "Manager-E-Mail muss mit einem vorhandenen Benutzer im System übereinstimmen",
        "circularDependencyReview": "Bitte überprüfe die Eltern-Kind-Beziehungen, um sicherzustellen, dass keine zirkulären Abhängigkeiten bestehen.",
        "useBatchAbbreviation": "\"{{abbreviation}}\" als Batch-Abkürzung verwenden",
        "existingDepartments": "Bestehende Abteilungen (Datenbank)",
        "batchDepartments": "Batch-Abteilungen (Aktueller Upload)"
      },
      "deletePhrase": "diese Abteilung"
    },
    "orgFunctions": {
      "details": "Funktionsdetails",
      "namePlaceholder": "Funktionsname eingeben",
      "emailPlaceholder": "E-Mail-Adresse eingeben",
      "descriptionPlaceholder": "Beschreibung eingeben",
      "selectDepartment": "Abteilung auswählen",
      "noDepartment": "Keine Abteilung",
      "selectLead": "Funktionsleitung auswählen",
      "selectTeamLead": "Teamleitung auswählen",
      "noLead": "Keine Funktionsleitung",
      "noTeamLead": "Keine Teamleitung",
      "email": "Geteiltes Postfach",
      "lead": "Funktionsleitung",
      "teamLead": "Teamleitung",
      "department": "Abteilung",
      "kind": {
        "label": "Art",
        "team": "Team",
        "role": "Funktion"
      },
      "members": {
        "title": "Personen",
        "empty": "Keine Personen gefunden",
        "search": "Personen suchen...",
        "leadBadge": "Funktionsleitung",
        "label": "Personen (weitere Funktion)",
        "hint": "Ausgewählte Personen erhalten diese Funktion als weitere Funktion neben ihrer Stelle.",
        "hintMainRoleLocked": "Personen, deren Stelle diese Funktion ist, sind gesperrt vorausgewählt.",
        "available": "Verfügbare Personen",
        "selected": "Ausgewählte Personen",
        "filterByDepartment": "Nach Abteilung filtern",
        "loadError": "Die Personen dieser Funktion konnten nicht geladen werden. Schließe den Dialog und versuche es erneut, um sie zu bearbeiten.",
        "mainRoleLocked": "Diese Funktion ist als Stelle zugewiesen und kann hier nicht entfernt werden – ändere dazu die Stelle der Person."
      },
      "memberCount": "Personen",
      "deletePhrase": {
        "team": "dieses Team",
        "role": "diese Funktion"
      }
    },
    "functions": {
      "title": "Funktionen",
      "description": "Alle Funktionen in deiner Organisation verwalten",
      "empty": "Keine Funktionen gefunden",
      "search": "Funktionen suchen...",
      "create": "Funktion erstellen",
      "createDescription": "Füge eine neue Funktion zu deiner Organisation hinzu.",
      "edit": "Funktion bearbeiten",
      "editDescription": "Aktualisiere die Details dieser Funktion",
      "detailDescription": "Funktionsdetails anzeigen",
      "notFound": "Funktion nicht gefunden"
    },
    "teams": {
      "title": "Teams",
      "description": "Alle Teams in deiner Organisation verwalten",
      "empty": "Keine Teams gefunden",
      "search": "Teams suchen...",
      "create": "Team erstellen",
      "createDescription": "Füge ein neues Team zu deiner Organisation hinzu.",
      "edit": "Team bearbeiten",
      "editDescription": "Aktualisiere die Details dieses Teams",
      "detailDescription": "Teamdetails anzeigen",
      "notFound": "Team nicht gefunden"
    },
    "myOrgFunctions": {
      "title": "Meine Funktionen",
      "description": "Siehe dir an in welchen Funktionen und Teams du in deinem Unternehmen agierst.",
      "empty": "Dir wurde noch keine Funktion zugewiesen."
    },
    "members": {
      "title": "Personen",
      "description": "Übersicht aller Mitarbeiter in deiner Organisation",
      "empty": "Keine Personen gefunden",
      "search": "Personen suchen...",
      "createMember": "Person erstellen",
      "inviteAllInactive": "Alle inaktiven Benutzer einladen",
      "inviteAllInactiveConfirm": "Einladungs-E-Mails an {{count}} inaktive(n) Benutzer senden?",
      "inviteAllInactiveSuccess": "{{count}} Einladung(en) gesendet",
      "inviteAllInactiveSkipped": "{{count}} Benutzer wurden übersprungen",
      "editMember": "Person bearbeiten",
      "createMemberDescription": "Füge eine neue Person zu deiner Organisation hinzu.",
      "editMemberDescription": "Aktualisiere die Details dieser Person",
      "notFound": "Person nicht gefunden",
      "detailDescription": "Personendetails anzeigen und verwalten",
      "details": "Personendetails",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "firstNamePlaceholder": "Vornamen eingeben",
      "lastNamePlaceholder": "Nachnamen eingeben",
      "emailPlaceholder": "E-Mail-Adresse eingeben",
      "emailChangeWarning": "Damit änderst du die E-Mail-Adresse, mit der sich diese Person anmeldet.",
      "relationships": "Zuordnung",
      "selectDepartment": "Abteilung auswählen",
      "mainRole": "Stelle",
      "selectMainRole": "Stelle auswählen",
      "secondaryRoles": "Weitere Funktionen",
      "selectSecondaryRoles": "Weitere Funktionen auswählen",
      "location": "Standort",
      "selectLocation": "Standort auswählen",
      "accessPermissions": "Zugriff & Berechtigungen",
      "selectUserTypes": "Benutzertypen auswählen",
      "selectClassification": "Klassifizierung auswählen",
      "externalOrganization": "Externe Organisation",
      "externalOrgPlaceholder": "Namen der externen Organisation eingeben",
      "sendInvitation": "Einladungs-E-Mail senden",
      "sendInvitationHelper": "Die Person wird per E-Mail benachrichtigt.",
      "statusActions": "Aktionen",
      "sendInvitationAction": "Einladung senden",
      "resendInvitationAction": "Einladung erneut senden",
      "userInactive": "Dieser Benutzer wurde noch nicht eingeladen",
      "userPendingInvitation": "Dieser Benutzer wartet auf die Kontoaktivierung. Du kannst die Einladung bei Bedarf erneut senden.",
      "userSuspended": "Dieser Benutzer ist derzeit gesperrt",
      "suspendUser": "Benutzer sperren",
      "unsuspendUser": "Benutzer entsperren",
      "sendInvitationSuccess": "Einladung gesendet",
      "suspendSuccess": "Benutzer gesperrt",
      "unsuspendSuccess": "Benutzer entsperrt",
      "suspendUserPrompt": "Du kannst diesen Benutzer sperren, um den Zugriff vorübergehend zu entziehen",
      "resetSignInAction": "Anmeldung zurücksetzen",
      "resetSignInDescription": "Die aktuellen Anmeldemethoden von {{name}} ({{email}}) – Passwort, Passkeys, Authenticator-Apps – funktionieren nicht mehr, und die Person wird aus allen Workspaces abgemeldet. Sie erhält eine E-Mail, um ihre Anmeldung neu einzurichten, und kann sich erst danach wieder anmelden.",
      "resetSignInConfirmInstruction": "Gib <strong /> ein, um das Zurücksetzen zu bestätigen.",
      "resetSignInConfirmLabel": "Name der Person",
      "resetSignInSuccess": "Anmeldung zurückgesetzt. Eine E-Mail zur Neueinrichtung wurde gesendet.",
      "homeOrgDeletedBadge": "Heimatorganisation gelöscht",
      "homeOrgDeletedTooltip": "Die Heimatorganisation dieser Person wurde gelöscht — die Anmeldung ist (oder wird) blockiert. Ein Plattform-Administrator kann eine neue Heimatorganisation zuweisen, um den Zugang wiederherzustellen.",
      "deletePhrase": "diese Person"
    },
    "contacts": {
      "title": "Externe Kontakte",
      "description": "Übersicht aller externen Kontakte",
      "empty": "Keine externen Kontakte gefunden",
      "search": "Externe Kontakte suchen...",
      "create": "Kontakt erstellen",
      "notFound": "Kontakt nicht gefunden",
      "detailDescription": "Kontaktdetails anzeigen und verwalten",
      "details": "Kontaktdetails",
      "deletePhrase": "diesen Kontakt"
    },
    "externalContacts": {
      "createContact": "Kontakt erstellen",
      "editContact": "Kontakt bearbeiten",
      "createContactDescription": "Füge einen neuen externen Kontakt hinzu.",
      "editContactDescription": "Aktualisiere die Details dieses Kontakts",
      "nameLabel": "Kontaktname",
      "typeSectionLabel": "Kontakttyp",
      "typeLabel": "Kontakttyp (aus Liste wählen oder neu anlegen)",
      "namePlaceholder": "Kontaktname eingeben (z.B. Musterbank, Privatkunde)",
      "typePlaceholder": "Kontakttyp auswählen",
      "descriptionPlaceholder": "Beschreibung eingeben",
      "types": {
        "customer": "Kunde",
        "partner": "Partner",
        "vendor": "Lieferant",
        "other": "Sonstiges"
      }
    },
    "artifacts": {
      "title": "Unterlagen",
      "description": "Übersicht aller Unterlagen, die in euren Organisationsprozessen genutzt werden",
      "empty": "Keine Unterlagen gefunden",
      "search": "Unterlagen suchen...",
      "size": "Größe",
      "createdBy": "Erstellt von",
      "type": "Dateiformat",
      "fileUrl": "Link zum Dokument",
      "create": "Unterlage erstellen",
      "editArtifact": "Unterlage bearbeiten",
      "createArtifactDescription": "Füge eine neue Unterlage hinzu",
      "editArtifactDescription": "Aktualisiere die Details dieser Unterlage",
      "namePlaceholder": "z.B. Checkliste Kundenklassifikation",
      "descriptionPlaceholder": "z.B. Prüfliste für die Kundeneinstufung.",
      "typePlaceholder": "z.B. PDF, Excel, Word",
      "fileUrlPlaceholder": "https://beispiel.de/datei.pdf",
      "notFound": "Unterlage nicht gefunden",
      "detailDescription": "Unterlagendetails anzeigen und verwalten",
      "details": "Unterlagendetails",
      "addNew": "Neu erstellen",
      "types": {
        "document": "Dokument",
        "image": "Bild",
        "video": "Video",
        "other": "Sonstiges"
      },
      "deletePhrase": "diese Unterlage"
    }
  },
  "organizations": {
    "Level": "Ebene",
    "Abbreviation": "Abkürzung",
    "Description": "Beschreibung",
    "ParentDepartment": "Übergeordnete Abteilung"
  },
  "OrgSettingPage": {
    "Settings": "Einstellungen",
    "editKeyDetails": "Konfiguriere die Einstellungen deiner Organisation",
    "OrganizationLogo": "Organisationslogo",
    "Upload": "Hochladen",
    "Organizationname": "Organisationsname",
    "Language": "Sprache",
    "RecordingTime": "Standardaufnahmezeit (Stunden)",
    "recordingTimeHint": "Wie lange soll es dauern, bis eine zugewiesene Prozessschritt-Aufnahme als 'Überfällig' gilt",
    "reviewTimeFrame": "Standard Prozess-Überprüfungszeitraum",
    "reviewTimeFrameHint": "Nach wie vielen Tagen möchtet ihr den selben Prozess noch einmal aufnehmen, um zu schauen, ob er sich verändert hat?",
    "RatingAndComment": "Bewertung und Kommentar",
    "FrequencyMeasurement": "Frequenz",
    "DurationMeasurement": "Dauer",
    "VariantCheck": "Variantenabfrage",
    "SettingSaved": "Einstellung erfolgreich gespeichert.",
    "ExportData": "Daten exportieren",
    "ExportDataSuccess": "Daten erfolgreich exportiert!",
    "days": "Tage",
    "hours": "Stunden",
    "logoUploadHint": "SVG, PNG, JPG oder GIF (max. 800x800px) oder 3MB",
    "fieldRequired": "Feld ist erforderlich.",
    "noCommaAllowed": "Wert darf kein Komma enthalten.",
    "mustBePositive": "Wert muss größer als 0 sein.",
    "internalBillingRate": "Verrechnungssatz",
    "internalBillingRateUnit": "€/Std.",
    "languageEnglish": "English",
    "languageGerman": "Deutsch",
    "languageHungarian": "Magyar",
    "languageFrench": "Français",
    "organizationProfileTitle": "Organisationsprofil",
    "organizationProfileDesc": "Verwalte Logo und Identität deiner Organisation.",
    "preferencesTitle": "Einstellungen",
    "preferencesDesc": "Lege Standardwerte für deine Organisation fest.",
    "surveySettingsTitle": "Umfrageeinstellungen",
    "surveySettingsDesc": "Steuere, welche Umfragen Personen nach der Aufnahme angezeigt wird und welche Werte abgefragt werden sollen",
    "capacityPriority": "Kapazitätsquelle",
    "capacityPrioritySurveyFirst": "Erhoben zuerst",
    "capacityPrioritySurveyFirstDesc": "Erhobener Wert; fehlt er, zählt der manuelle Wert.",
    "capacityPriorityManualFirst": "Manuell zuerst",
    "capacityPriorityManualFirstDesc": "Manueller Wert; fehlt er, zählt der erhobene Wert.",
    "capacityPrioritySurveyOnly": "Nur erhoben",
    "capacityPrioritySurveyOnlyDesc": "Nur erhobene Werte zählen. Manuelle Werte bleiben gespeichert.",
    "capacityPriorityManualOnly": "Nur manuell",
    "capacityPriorityManualOnlyDesc": "Nur manuelle Werte zählen. Erhobene Werte bleiben gespeichert.",
    "privacyMode": "Prozess-Sichtbarkeit",
    "privacyNeedToKnow": "Need-to-Know",
    "privacyNeedToKnowDesc": "Benutzer sehen nur Prozesse, denen sie zugewiesen sind",
    "privacyFullTransparency": "Volle Transparenz",
    "privacyFullTransparencyDesc": "Alle Benutzer können jeden Prozess sehen",
    "ai": {
      "title": "KI-Funktionen",
      "description": "KI-gestützte Funktionen für deine Organisation aktivieren und konfigurieren",
      "bliksyEnableLabel": "Bliksy aktivieren",
      "bliksyEnableDescription": "Benutzern erlauben, den Bliksy KI-Assistenten während der Aufnahme zu verwenden",
      "stepNameGenerationLabel": "Schrittnamen automatisch generieren",
      "stepNameGenerationDescription": "Automatisch Namen und Beschreibungen für aufgenommene Prozessschritte mittels KI generieren",
      "appsTitle": "KI-Funktionen der Apps",
      "appsDescription": "Einzelne KI-Funktionen der Apps deiner Organisation ein- oder ausschalten. Ist eine Funktion aus, blendet die App sie aus."
    }
  },
  "department": {
    "tabs": {
      "members": "Personen",
      "teams": "Teams"
    },
    "selector": {
      "placeholder": "Abteilung auswählen..."
    },
    "members": {
      "title": "Personen in meiner Abteilung",
      "description": "Personen der Abteilung {{department}} verwalten",
      "descriptionDefault": "Verwalte die Personen deiner Abteilung",
      "empty": "Keine Personen in deiner Abteilung gefunden",
      "search": "Personen suchen...",
      "createMember": "Person hinzufügen"
    },
    "teams": {
      "title": "Meine Abteilungsteams",
      "description": "Teams der Abteilung {{department}} verwalten",
      "descriptionDefault": "Verwalte die Teams deiner Abteilung",
      "empty": "In deinen Abteilungen existieren keine fixen Teams",
      "search": "Teams suchen...",
      "createTeam": "Team hinzufügen",
      "noAccess": "Du verwaltest keine Abteilung."
    }
  },
  "organizationSettings": {
    "userManagement": {
      "title": "Benutzerverwaltung",
      "description": "Verwalte Benutzerzugriff, -typen und -berechtigungen für deine Organisation."
    },
    "softwareList": {
      "title": "Softwareliste",
      "description": "Verwalte und konfiguriere Softwaresysteme, die von deiner Organisation verwendet werden.",
      "create": "System erstellen",
      "empty": "Keine Systeme gefunden"
    }
  }
}
